import type { ThreadTopicSummary } from '@shared/types/thread-work';
import { Button } from '@/components/ui';
import { PassToForm } from '@/components/activity/PassToForm';
import { useKeyShortcut } from '@/lib/use-key-shortcut';
import { usePopover } from './usePopover';

/** « Passer à… » one next action of an object (relais): a colleague, a word. */
export const AppRecordPassTo = ({ topic, onDone, hotkey }: {
  topic: ThreadTopicSummary;
  onDone: () => void;
  /** In a séance, the key that opens it. */
  hotkey?: string;
}) => {
  const { open, setOpen, ref } = usePopover();
  useKeyShortcut(hotkey ?? '', () => setOpen(true), Boolean(hotkey));
  return (
    <div ref={ref} className="relative">
      <Button variant="secondary" aria-expanded={open} onClick={() => setOpen(!open)} title={hotkey ? `Raccourci : ${hotkey.toUpperCase()}` : undefined}>
        Passer à…
      </Button>
      {open && (
        <div className="absolute left-0 top-11 z-20 w-72 overflow-hidden rounded-2xl border border-domino-cardBorder bg-domino-white shadow-[var(--domino-shadow-elevated)]">
          <PassToForm topic={topic} onDone={() => { setOpen(false); onDone(); }} />
        </div>
      )}
    </div>
  );
};
